var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customer.birthdate)?_c('span',[_c('span',{staticClass:"is-small",class:{'is-success': _vm.hasNearBirthday, 'tag': _vm.tag}},[_vm._m(0),_c('span',[_vm._v(_vm._s(_vm.formattedBirthday))])])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"mdi mdi-cake-variant"})])
}]

export { render, staticRenderFns }